'use client';
import { FestivalProvider } from '@/contexts/FestivalContext';
const FestivalsLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <FestivalProvider>
        {children}
      </FestivalProvider>
    </>
  );
};

export default FestivalsLayout;
